import { render } from "./Register-employer.vue?vue&type=template&id=5e727fb6&ts=true"
import script from "./Register-employer.vue?vue&type=script&lang=ts"
export * from "./Register-employer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__